import React, { Component } from 'react';
import PropTypes from 'prop-types';

import fetchWP from '../utils/fetchWP';
import Notice from '../components/notice';
import LanguageSelection from '../components/language-selection'
import ButtonSettings from '../components/button-settings'

import OtherSettings from '../components/other-settings'
import { Form, Row, Col, Button, Input, Card } from 'antd';
import 'antd/dist/antd.css';
import '../styles/admin.css';

const requirementsData = {
  'isPermalinkEnabled' : "Permalinks needs to be enabled in order to use this plugin. You can enable them by going to Settings -> Permalinks"
};

const FormItem = Form.Item

Object.compare = function (obj1, obj2) {
	//Loop through properties in object 1
	for (var p in obj1) {
		//Check property exists on both objects
		if (obj1.hasOwnProperty(p) !== obj2.hasOwnProperty(p)) return false;

		switch (typeof (obj1[p])) {
			//Deep compare objects
			case 'object':
				if (!Object.compare(obj1[p], obj2[p])) return false;
				break;
			//Compare function code
			case 'function':
				if (typeof (obj2[p]) == 'undefined' || (p != 'compare' && obj1[p].toString() != obj2[p].toString())) return false;
				break;
			//Compare values
			default:
				if (obj1[p] != obj2[p]) return false;
		}
	}

	//Check object 2 for any extra properties
	for (var p in obj2) {
		if (typeof (obj1[p]) == 'undefined') return false;
	}
	return true;
};

@Form.create()
export default class Admin extends Component {
  constructor(props) {
    super(props);

    this.state = {
      apiKey: '',
      notice: false,
      sourceLanguage : '',
      targetLanguages : [],
      buttonType : 'list',
      buttonPosition : 'bl',
      excludePaths : [],
      ignoreClasses : [],
      autoRedirect : false,
      currentData : {},
			missingRequirements : []
    };

    this.fetchWP = new fetchWP({
      restURL: this.props.wpObject.api_url,
      restNonce: this.props.wpObject.api_nonce,
    });

    this.getSetting();
  }

	componentDidMount() {
		this.checkRequirements();
	}

	checkRequirements = () => {

		const { requirements } = this.props.wpObject;
		const missingRequirements = []

		if (requirements && typeof requirements == 'object') {
			Object.keys(requirements).forEach(req => {
				if(requirementsData.hasOwnProperty(req) && requirements[req] == false) {
					missingRequirements.push(requirementsData[req])
					this.setState({
						missingRequirements
					})
				}
			})
		}
	}

  getSetting = (sync = false, apiKey = "") => {

    let path = "admin"

    //sync, get data from api and update

    if(sync)
        path += "?sync=true&apiKey=" + apiKey

    this.fetchWP.get( path )
    .then(
      (json) => {
          const currentData = json.value
          const data = { ...currentData, ...{ currentData } }
          this.setState(data)
      },
      (err) => console.log( 'error', err )
    );
  };

  updateSetting = () => {
    this.fetchWP.post( 'admin', { apiKey: this.state.apiKey } )
    .then(
      (json) => this.processOkResponse(json, 'saved'),
      (err) => this.setState({
        notice: {
          type: 'error',
          message: err.message, // The error message returned by the REST API
        }
      })
    );
  }

  deleteSetting = () => {
    this.fetchWP.delete( 'admin' )
    .then(
      (json) => this.processOkResponse(json, 'deleted'),
      (err) => console.log('error', err)
    );
  }

  processOkResponse = (json, method) => {
    if (json.success) {
        const currentData = json.value
        const data = {
            ...currentData,
            ...{
                currentData,
                notice: {
                    type: 'success',
                    message: `Setting ${method} successfully.`,
                }
            }
        }

        this.setState(data)

    } else {
        this.setState({
            notice: {
              type: 'error',
              message: `Setting was not ${method}.`,
            }
        });
      console.log(`Setting was not ${method}.`, json);
    }
  }

  updateInput = (event) => {
    this.setState({
      apiKey: event.target.value,
    });
  }

  handleSave = (event) => {
    event.preventDefault();

    this.updateSetting();
  }

  handleDelete = (event) => {
    event.preventDefault();
    this.deleteSetting();
  }

  clearNotice = () => {
    this.setState({
      notice: false,
    });
  }

  handleSubmit(event) {

      event.preventDefault()
      const { form } = this.props

      let currrentValues = this.state.currentData;
      let currrentValuesKeys = Object.keys(currrentValues)
      form.validateFields((error, values) => {

        if (!error) {

            if(values.targetLanguages) {
                values.targetLanguages = values.targetLanguages.map(lang => lang.key)
            }

            if(values.excludePaths) {
                values.excludePaths = values.excludePaths.filter(Boolean)
            }

            if(values.ignoreClasses) {
                values.ignoreClasses = values.ignoreClasses.filter(Boolean)
            }

            let compareValue = {}
            currrentValuesKeys.forEach(val => {
                compareValue[val] = values[val]
            })

						const { buttonType, buttonPosition } = values

						compareValue['buttonSettings'] = {
							buttonType,
							buttonPosition
						}

            //Cast to boolean
            compareValue.addFlags = compareValue.addFlags == "true" ? true : false;

            //Save only when they are different
            const shouldSave = !Object.compare(currrentValues, compareValue)

            if(shouldSave) {
                this.fetchWP.post( 'admin', values )
                .then(
                  (json) =>  this.processOkResponse(json, 'saved'),
                  (err) => this.setState({
                    notice: {
                      type: 'error',
                      message: err.message, // The error message returned by the REST API
                    }
                  })
                );
            }else {
                this.setState({
                    notice: {
                      type: 'warning',
                      message: 'Nothing changed.',
                    }
                })
            }

        }
      })
  }

  handleApiBlur(event) {
      if(this.state.apiKey != "")
        return;

      //This is the initial setup
      try {
          const apiKey = event.target.value;

          //Make sure it is valid key and user is done entering
          if(apiKey.length == 32) {
              this.getSetting(true, apiKey)
          }
      }catch(e) {

      }

  }


  render() {

      let noticeHtml, missingRequirementsHtml;

			const { notice, missingRequirements } = this.state;

      if (notice ) {
          noticeHtml = <Notice notice={this.state.notice} onDismissClick={this.clearNotice} />
      }

			if (missingRequirements && missingRequirements.length > 0) {
				missingRequirementsHtml = missingRequirements.map(req => {
					let reqNotice = {
						type : 'error',
						message : req
					}

					return <Notice notice={reqNotice} duration={0} showDismiss={false}/>
				})
			}

      const formItemLayout = {
          labelCol: {
            xs: { span: 24 },
            sm: { span: 4 },
          },
          wrapperCol: {
            xs: { span: 24 },
            sm: { span: 12 },
          },
      };

    const url = this.props.wpObject.app_url || "https://app.teral.io"
    const cdnHost = this.props.wpObject.cdn_host || "https://cdn.teral.io"

    const appUrl = {
        "dashboard":  url + "/dashboard",
        "translations" : url + "/translations",
        "login" : url + "/login"
    }

    const apiKey = this.state.apiKey

    return (
      <div id="teral-app-container" className="wrap">
					 {missingRequirementsHtml}
           {noticeHtml}

        <Form {...formItemLayout} onSubmit={this.handleSubmit.bind(this)}>
            <Row className="teral-section">
                <Col>
                    <div className="headerButton">
                        <Button size="large" target="_blank" href={appUrl.dashboard}>Dashboard</Button>
                        <Button size="large" target="_blank" href={appUrl.translations}>Edit Translations</Button>
                    </div>
                </Col>
            </Row>

            <Row className="teral-section">
							<Card title="Api Info" bordered={false} >
								<FormItem label="Api Key" help=<p>You can get your api key by logging in <a target="_blank" href={appUrl.login}>here</a></p>>
									{this.props.form.getFieldDecorator('apiKey', {
											initialValue : apiKey || "",
											rules: [{ required: true, message: 'Api Key is required' }],
									})(
										 <Input onBlur={this.handleApiBlur.bind(this)} className="field-apiKey"/>
									)}
								</FormItem>
							</Card>
            </Row>

            <Row className="teral-section">
							<Card title="Language Selection" bordered={false} >
								<LanguageSelection
										form={this.props.form}
										sourceLanguage={this.state.sourceLanguage}
										targetLanguages={this.state.targetLanguages}
								/>
							</Card>
            </Row>

            <Row className="teral-section">
							<Card title="Button Settings" bordered={false} >
								<ButtonSettings
                    apiKey={this.state.apiKey}
										cdnHost={cdnHost}
										form={this.props.form}
										buttonType={this.state.buttonType}
										buttonPosition={this.state.buttonPosition}
								/>
							</Card>
            </Row>

            <Row className="teral-section">
							<Card title="Other Settings" bordered={false} >
								<OtherSettings
										form={this.props.form}
										excludePaths={this.state.excludePaths}
										ignoreClasses={this.state.ignoreClasses}
                    autoRedirect={this.state.autoRedirect}
								/>
							</Card>
            </Row>

            <Button htmlType="submit" >Save</Button>
        </Form>


      </div>
    );
  }
}

Admin.propTypes = {
  wpObject: PropTypes.object
};
